module.exports = __webpack_public_path__ + "media/images/check-cd795bae.png";